<template>
  <el-table-column
    prop="customer_name"
    sortable="custom"
    label="Átvevő"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'customer_name',
  };
</script>
